import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulkLabeling = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M7 18C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H9C8.44772 8 8 8.44772 8 9V17C8 17.5523 7.55228 18 7 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M4 15C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H6C5.44772 5 5 5.44772 5 6V14C5 14.5523 4.55228 15 4 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .1,
			x: 10,
			y: 10,
			width: 10,
			height: 10,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19 12C19 11.4477 18.5523 11 18 11H12C11.4477 11 11 11.4477 11 12V18C11 18.5523 11.4477 19 12 19H18C18.5523 19 19 18.5523 19 18V12ZM10 9C9.44772 9 9 9.44772 9 10V20C9 20.5523 9.44772 21 10 21H20C20.5523 21 21 20.5523 21 20V10C21 9.44772 20.5523 9 20 9H10Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgBulkLabeling);
export { ForwardRef as ReactComponent };
